const SectionLabel = ({ icon, children }) => (
  <div className="flex items-center gap-2 mb-4">
    <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 bg-blue-700/10 dark:bg-blue-500/20">
      <span className="text-blue-700 dark:text-blue-400">{icon}</span>
    </div>
    <p className="text-xs font-bold uppercase tracking-widest text-blue-700 dark:text-blue-400">
      {children}
    </p>
  </div>
);

export default SectionLabel;
